import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { requirePermission } from "../../../../shared/routing/requirePermission";
import { INDIVIDUALS_VIEW } from "../../organizationPermissions";
import type { OrganizationRouteFactory } from "./organizationRouteContext";

const IndividualsListScreen = lazyRouteComponent(
  () => import("../IndividualsListScreen"),
  "IndividualsListScreen",
);

// Individuals is a permission-grantable placeholder (see REBUILD-PLAN's
// roles-matrix requirement) — no repository, no search params, until the real
// screen is built. Regions, branches and departments have their own real
// routes now (see createRegionsRoutes/createBranchesRoutes/
// createDepartmentsRoutes).
export const createOrganizationStubRoutes: OrganizationRouteFactory = ({
  context,
}) => [
  createRoute({
    getParentRoute: context.getParentRoute,
    path: `${context.basePath}/individuals`,
    beforeLoad: requirePermission([INDIVIDUALS_VIEW]),
    component: IndividualsListScreen,
  }),
];
